import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { selectCurrentPage, selectPartnerDiscounts, selectPartnerDiscountsLoading, selectTotalPages, setPage } from "../../model"
import { IPartnerDiscount } from "@/shared/api/partners"
import { ColumnDef } from "@tanstack/react-table"
import { Table } from "@/shared/ui/table"
import { Loader } from "@/shared/ui/loader"
import { NoTableData } from "@/shared/ui/no-table-data"
import { Pagination } from "@/shared/ui/pagination"
import { DeleteDiscount } from "../delete-discount"
import { UpdateDiscount } from "../update-discount"
import { toLocaleDateString } from "@/shared/lib/date-formatters"

export const PartnerDiscountsTable = () => {
    const discounts = useAppSelector(selectPartnerDiscounts)
    const isLoading = useAppSelector(selectPartnerDiscountsLoading)
    const page = useAppSelector(selectCurrentPage)
    const totalPages = useAppSelector(selectTotalPages)
    const dispatch = useAppDispatch()

    const columns: ColumnDef<IPartnerDiscount, any>[] = [
        {
            accessorFn: (discount) => (
                <div className="w-full">
                    {discount.started_date ? toLocaleDateString(discount.started_date) : "—"}
                </div>
            ),
            id: 'startDate',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap">Дата начала</div>,
        },
        {
            accessorFn: (discount) => (
                <div>
                    {discount.finished_date ? toLocaleDateString(discount.finished_date) : "—"}
                </div>
            ),
            id: 'endDate',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap">Дата окончания</div>,
        },
        {
            accessorFn: (discount) => (
                <div>
                    {discount.accrual_type === 1 && `${discount.value} %`}
                    {discount.accrual_type === 2 && `${discount.value} ₽`}
                </div>
            ),
            id: 'discount',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap">Скидка</div>,
        },
        {
            accessorFn: (discount) => (
                <div>
                    {discount.priority}
                </div>
            ),
            id: 'priority',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap">Приоритет</div>,
        },
        {
            accessorFn: (discount) => (
                <div className="w-fit">
                    <div className="text-[13px] rounded-full text-nowrap bg-color-primary py-[6px] px-3 font-normal">
                        {discount.id}
                    </div>
                </div>
            ),
            id: 'id',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap">ID</div>,
        },
        {
            accessorFn: (discount) => (
                <div className="w-full flex justify-end gap-2">
                    <UpdateDiscount discount={discount} />
                    <DeleteDiscount discount={discount} />
                </div>
            ),
            id: 'actions',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div />,
        },
    ]

    return (
        <>
            {Boolean(discounts.length) &&
                <div className="table_box">
                    <Table columns={columns} data={discounts} />
                    <Pagination 
                        page={page} 
                        totalPages={totalPages} 
                        setPage={(page) => dispatch(setPage(page))}                    
                    />
                </div>
            }
            {(!Boolean(discounts.length) && isLoading) &&
                <div className="info_panel">
                    <Loader />
                </div>
            }
            {(!Boolean(discounts.length) && !isLoading) &&
                <NoTableData label="Нет данных о скидках" />
            }
        </>
    )
}